<template>
    <div class="material-pages-wrapper">
        <website-header style="position:absolute;"></website-header>
        <div class="content">
            <div class="background">
                <div class="central-gray-backdrop"></div>
                <div class="left-triangle-bubble"></div>
                <div class="right-circle-bubble"></div>
                <div class="top-circle-bubble"></div>
                <div class="bottom-rounded-rectangle-bubble"></div>
                <div class="central-circle-bubble"></div>
                <div class="top-left-accessor"></div>
                <div class="bottom-right-accessor"></div>
            </div>
            <div class="master-vision">
                <div class="aside">
                    <div class="slogan">{{$t("indexmaterial.slogan")}}</div>
                    <div class="download">
                        <p class="tips">{{$t('indexmaterial.download_appstore_tips')}}</p>
                        <a class="dl-link appstore" target="_blank" :href="downloads.applestore"></a>
                        <a class="dl-link android" target="_blank" :href="downloads.android"></a>
                    </div>
                </div>
            </div>
            <div class="helpful-tips" v-if="showDownload === false">如遇下載或使用問題，請聯繫我們（<a
                    href="mailto:livemetw@liveme.com">livemetw@liveme.com</a>）</div>
        </div>
        <div class="previous-partner">{{$t("indexmaterial.prevpartner")}}</div>
        <website-footer></website-footer>
    </div>
</template>
<script>
import ReHeader from '../../../basic/re_header';
import ReFooter from '../../../basic/alive-footer';

export default {
    name: 'indexmaterial',
    components: {
        'website-header': ReHeader,
        'website-footer': ReFooter
    },

    data() {
        return {
            downloads: {}
        };
    },
    async created() {
        this.downloads = {
            applestore: 'https://apps.apple.com/us/app/id1487793975',
            android: 'https://guanwang.onelink.me/IXGk/Alive0803Android'
        };
    },
    beforeMount() {
    },
    mounted() {
    },
    methods: {
    }
};
</script>
<style lang="less">
    @import "../../css/view-index-alive.less";
</style>
